import { IndividualCost } from '../../models/interface/additional-cost';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

export function costEqualsPayout(
  cost: IndividualCost,
  payout: Payout,
): boolean {
  if (cost.title === payout.name) {
    return true;
  }
  return false;
}

export function findMatchingPayout(
  cost: IndividualCost,
  charter: Charter,
): Payout {
  let matchingPayout = null;
  charter.payouts.forEach((payout) => {
    if (costEqualsPayout(cost, payout)) {
      matchingPayout = payout;
    }
  });
  return matchingPayout;
}
